/**
 * [INPUT]: 依赖 Base UI Button、class-variance-authority 与 cn
 * [OUTPUT]: 对外提供 Button 组件及主次、幽灵、危险变体
 * [POS]: ui 的交互原子，统一 40px 控件、焦点环和禁用语义
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { Button as BaseButton } from '@base-ui/react/button'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'

import { cn } from './utils'

const buttonVariants = cva('button', {
  variants: {
    variant: {
      primary: 'button-primary',
      secondary: 'button-secondary',
      ghost: 'button-ghost',
      danger: 'button-danger',
    },
    size: { default: '', compact: 'button-compact', icon: 'button-icon' },
  },
  defaultVariants: { variant: 'secondary', size: 'default' },
})

export type ButtonProps = ComponentProps<typeof BaseButton> & VariantProps<typeof buttonVariants>

export function Button({ className, variant, size, ...props }: ButtonProps) {
  return <BaseButton className={cn(buttonVariants({ variant, size }), className)} {...props} />
}
